module.exports = __webpack_public_path__ + "static/img/C0A0EA0-A4AC4F1-E0FBF72.1f74aba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/C0A0EA0-A4AC4F1-E0FBF72.jpg
// module id = ZTdY
// module chunks = 3